import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/pro-invite-reminders')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/professionals/invites' });
  },
});
